<template>
  <div>
    <div id="splash-screen" :class="{ loader: true, fadeout: !isLoading }">
      <div>
        <h1>
          ECCHR <br />
          Explore
        </h1>
        <video
          ref="videoRef"
          autoplay
          src="../assets/loading.mp4"
          muted="muted"
          playsinline
        ></video>
        <p>Dive into our conversations around Arts and Human Rights</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LoadingScreen",
  props: ["isLoading"],
  computed: {
    ...mapState(["device_mode"]),
  },
  // created() {
  //   if (this.device_mode == "desktop") {
  //     console.log("splash-screen");
  //   }
  // },
  mounted() {
    const SplashScreen = document.getElementById("splash-screen");
    // if (this.device_mode == "desktop") {
    if (window.screen.width < window.screen.height) {
      SplashScreen.style.width = "375px";
    } else {
      SplashScreen.style.borderRadius = "20px";
    }
    // const SplashScreen = document.getElementById("splash-screen");
    // if (this.device_mode == "desktop") {
    //   console.log("splash-screen");
    //   SplashScreen.style.width = "375px";
    // } else {
    //   SplashScreen.style.width = "100%";
    // }
    this.$refs.videoRef.play();
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@700&display=swap");

/* #splash-screen {
  display: block;
 width: 375px;
} */

.loader {
  z-index: 4;
  background-color: black;
  bottom: 0;
  color: white;
  display: block;
  font-size: 32px;
  left: 0;
  overflow: hidden;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
  /* border-radius: 20px; */
}

h1 {
  padding-top: 3vh;
  font-size: 45px;
  text-align: left;
  padding-left: 50px;
  font-weight: 700;
}

p {
  font-size: 28px;
  padding-left: 50px;
  padding-right: 43px;
  text-align: left;
  position: fixed;
  bottom: 3vh;
  font-weight: 700;
  width: 270px;
}

video {
  position: absolute;
  top: 20%;
  width: 90%;
  left: 50%;
  margin: top;
  margin-left: -50%; /* Half of the width */
  z-index: -1;
}

.fadeout {
  animation: fadeout 2s forwards;
}

@keyframes fadeout {
  to {
    opacity: 0;
    visibility: hidden;
  }
}
</style>
